



















































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { ReplySettingTabs, FieldSettingTabs } from '@/config/map.conf';
import ReplyFieldEdit from './components/reply-field-edit.vue';
import * as api from '@/api';

/**
 * sla设置
 *
 * @author liyuyao
 * @date 09/07/2020
 */
@Component({
    components: {
        ReplyFieldEdit
    }
})
export default class RgReply extends Vue {
    @State(state => state.cti.permission.rg_report)
    permission: boolean;
    @State(state => state.cti.env)
    env: string;

    fieldTab: string = 'pause';
    replyTab: string = 'comment';

    openAutoComment: boolean = false;
    // 用于保存后端返回的评论类型、摩西机器人、固定评论内容、摩西默认内容的ID
    autoCommentSwitchId: number = 0;
    autoCommentMosesId: number = 0;
    defaultItemId: number = 0;
    mosesItemId: number = 0;
    // textarea的绑定值
    autoCommentContent: string = '';
    // 固定评论内容和摩西默认内容
    defaultContent: string = '';
    mosesContent: string = '';
    // 输入的机器人ID
    mosesBotId: string = null;
    // 绑定成功的机器人ID
    bindMosesId: string = null;

    replySettingTabs: CommonTypes.mapObject[] = ReplySettingTabs;
    fieldSettingTabs: CommonTypes.mapObject[] = FieldSettingTabs;

    activeComment: string = '';
    // 常用回复必填开关
    requiredCommonReply = {
        pendingReasonRequire: true,
        closedReasonRequire: true,
        closedDescRequire: true,
        pendingDescRequire: true,
        resolutionRequire: true
    };
    pendingReasonSwitchLoading: boolean = false;

    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
    get autoCommentId() {
        return this.activeComment === 'default' ? this.defaultItemId : this.mosesItemId;
    }
    get mosesDetailURL() {
        return this.env === 'prod'
            ? `https://moses.sankuai.com/#/cms/detail/${this.bindMosesId}`
            : `https://moses.nlp.test.sankuai.com/#/cms/detail/${this.bindMosesId}`;
    }
    get mosesRobotURL() {
        return this.env === 'prod' ? 'https://moses.sankuai.com/#/cms/robot' : 'https://moses.nlp.test.sankuai.com/#/cms/robot';
    }

    async created() {
        this.getRequiredCommonReply();
    }

    @Watch('replyTab')
    onTabChanged(tab) {
        tab === 'auto_comment' && this.getRgAutoComment();
    }
    @Watch('activeComment', { immediate: true })
    onActiveChanged() {
        if (this.activeComment === 'default') {
            this.autoCommentContent = this.defaultContent;
        } else {
            this.autoCommentContent = this.mosesContent;
        }
    }

    async getRgAutoComment() {
        const res = await api.rgApi.getRgReplyText({
            type: 'AUTOCOMMENT',
            rgId: this.rgId
        });
        const { code, data } = res;
        if (code === 200) {
            data.items.forEach(item => {
                switch (item.type) {
                    case 'AUTOCOMMENT_IN_USE':
                        this.openAutoComment = item.content !== 'off';
                        if (this.openAutoComment) {
                            this.activeComment = item.content;
                        }
                        this.autoCommentSwitchId = item.id;
                        break;
                    case 'AUTOCOMMENT_CONTENT':
                        this.defaultContent = item.content;
                        this.defaultItemId = item.id;
                        break;
                    case 'AUTOCOMMENT_MOSES_DEFAULT':
                        this.mosesContent = item.content;
                        this.mosesItemId = item.id;
                        break;
                    case 'AUTOCOMMENT_MOSES_ID':
                        this.mosesBotId = item.content;
                        this.bindMosesId = item.content;
                        this.autoCommentMosesId = item.id;
                        break;
                    default:
                        break;
                }
            });
        }
    }

    async editAutoComment(type: string, id: number) {
        const isSwitch = type === 'switch';
        const isDefault = this.activeComment === 'default';
        const params = {
            id: id,
            content: '',
            type: '',
            rgId: this.rgId
        };
        switch (type) {
            case 'switch':
                params.content = this.openAutoComment ? (isDefault ? 'default' : 'moses') : 'off';
                params.type = 'AUTOCOMMENT_IN_USE';
                break;
            case 'moses':
                params.content = this.mosesBotId;
                params.type = 'AUTOCOMMENT_MOSES_ID';
                break;
            case 'text':
                if (!isDefault && !this.bindMosesId) {
                    this.$mtd.message({
                        message: '请先绑定摩西机器人',
                        type: 'error'
                    });
                    return;
                }
                params.content = this.autoCommentContent;
                params.type = isDefault ? 'AUTOCOMMENT_CONTENT' : 'AUTOCOMMENT_MOSES_DEFAULT';
                break;
            default:
                break;
        }
        try {
            const res = await api.rgApi.editReplyText(params);
            const { code } = res;
            if (code === 200) {
                !isSwitch && this.$mtd.message.success('保存成功');
                this.getRgAutoComment();
            }
        } catch (error) {
            console.log(error);
        }
    }

    async editRequiredCommonReply(type: string) {
        interface Params {
            rgId: number;
            pendingReasonRequire?: boolean;
            closedReasonRequire?: boolean;
            closedDescRequire?: boolean;
            pendingDescRequire?: boolean;
            resolutionRequire?: boolean;
        }
        const params: Params = {
            rgId: this.rgId
        };
        switch (type) {
            case 'pendingReasonRequire':
                params.pendingReasonRequire = this.requiredCommonReply.pendingReasonRequire;
                break;
            case 'closedReasonRequire':
                params.closedReasonRequire = this.requiredCommonReply.closedReasonRequire;
                break;
            case 'closedDescRequire':
                params.closedDescRequire = this.requiredCommonReply.closedDescRequire;
                break;
            case 'pendingDescRequire':
                params.pendingDescRequire = this.requiredCommonReply.pendingDescRequire;
                break;
            case 'resolutionRequire':
                params.resolutionRequire = this.requiredCommonReply.resolutionRequire;
                break;
        }
        try {
            const res = await api.rgApi.sendRgSetting(params);
            const { code } = res;
            if (code === 200) {
                this.$mtd.message.success('保存成功');
            }
        } catch (error) {
            console.log(error);
        }
    }

    async getRequiredCommonReply() {
        this.pendingReasonSwitchLoading = true;
        try {
            const res = await api.rgApi.getRgSetting(this.rgId);
            const { code, data } = res;
            if (code === 200) {
                this.requiredCommonReply.pendingReasonRequire = data.pendingReasonRequire || false;
                this.requiredCommonReply.closedReasonRequire = data.closedReasonRequire || false;
                this.requiredCommonReply.closedDescRequire = data.closedDescRequire || false;
                this.requiredCommonReply.pendingDescRequire = data.pendingDescRequire || false;
                this.requiredCommonReply.resolutionRequire = data.resolutionRequire || false;
            }
        } catch (error) {
            console.log('error', error);
        }
        this.pendingReasonSwitchLoading = false;
    }
}
